module.exports = __webpack_public_path__ + "img/temp_instagram5.4d63decf.jpg";